const React = require('react')
const { useHistory } = require('react-router-dom')
const { Table, UncontrolledTooltip } = require('reactstrap')
const { useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/blocks/index.css')

const NFTsTable = props => {
    const { data } = props

    const history = useHistory()
    const { network } = useNetworkConfig()
    const isMobile = useResponsive(BREAKPOINTS.medium)

    return (
        <Table responsive style={isMobile ? { display: 'block', overflowX: 'auto', whiteSpace: 'nowrap' } : {}}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Collection</th>
                    <th>Type</th>
                    <th>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>Transfers</span>
                            <span
                                id='transfers-tooltip'
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '4px'
                                }}
                            >
                                <i
                                    className='fas fa-circle-question'
                                    style={{
                                        fontSize: '14px',
                                        color: 'var(--grey-color)'
                                    }}
                                />
                            </span>
                            <UncontrolledTooltip placement='top' target='transfers-tooltip'>
                                This column displays the all-time total transfer count and is updated every few hours
                                instead of in real-time.
                            </UncontrolledTooltip>
                        </div>
                    </th>
                    <th>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>Owners</span>
                            <span
                                id='owners-tooltip'
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '4px'
                                }}
                            >
                                <i
                                    className='fas fa-circle-question'
                                    style={{
                                        fontSize: '14px',
                                        color: 'var(--grey-color)'
                                    }}
                                />
                            </span>
                            <UncontrolledTooltip placement='top' target='owners-tooltip'>
                                This column is updated every few hours instead of in real-time.
                            </UncontrolledTooltip>
                        </div>
                    </th>
                    <th>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>Total Assets</span>
                            <span
                                id='total-assets-tooltip'
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '4px'
                                }}
                            >
                                <i
                                    className='fas fa-circle-question'
                                    style={{
                                        fontSize: '14px',
                                        color: 'var(--grey-color)'
                                    }}
                                />
                            </span>
                            <UncontrolledTooltip placement='top' target='total-assets-tooltip'>
                                This column is updated every few hours instead of in real-time.
                            </UncontrolledTooltip>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {data?.map((nft, index) => (
                    <tr key={nft.tokenAddress}>
                        <td>
                            <span style={{ fontWeight: 'bold' }}>{index + 1}</span>
                        </td>
                        <td>
                            <span
                                id={`nft-${nft.tokenAddress}`}
                                className={`${network.name}-text-color-after cursor-pointer`}
                                onClick={() => history.push(`/${network.name}/token/${nft.tokenAddress}`)}
                            >
                                {nft.tokenName}
                            </span>
                            &nbsp;
                            <span style={{ fontSize: '12px', fontWeight: 'normal', color: 'var(--grey-color)' }}>
                                ({nft.tokenSymbol})
                            </span>
                            <UncontrolledTooltip placement='top' target={`nft-${nft.tokenAddress}`}>
                                {nft.tokenAddress}
                            </UncontrolledTooltip>
                        </td>
                        <td>
                            <span className='method-id'>{nft.tokenType}</span>
                        </td>
                        <td>{nft.totalTransfers.toLocaleString()}</td>
                        <td>{nft.totalHolders.toLocaleString()}</td>
                        <td>{nft.totalSupply.toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

module.exports = { NFTsTable }
